// Faixa de explicação curta no topo de uma página, igual à usada em Ajuda
// ("Central de Ajuda") -- ícone + título + um parágrafo dizendo pra que serve
// a tela, para reduzir confusão entre telas parecidas (ex.: Agendamentos vs.
// Pendências).
import React from "react";
import styled from "styled-components";

const Banner = styled.div`
  width: 92%;
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 18px;
  padding: 16px 20px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-left: 4px solid var(--accent);
  border-radius: 16px;
  box-shadow: var(--shadow);

  svg {
    flex-shrink: 0;
    margin-top: 2px;
    color: var(--accent);
  }

  .text {
    display: flex;
    flex-direction: column;
    gap: 3px;
  }

  strong {
    font-family: var(--font-display);
    font-size: 15px;
    font-weight: 700;
    color: var(--text);
  }

  p {
    margin: 0;
    font-size: 13px;
    line-height: 1.5;
    color: var(--text-muted);
  }
`;

interface InfoBannerProps {
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
}

const InfoBanner: React.FC<InfoBannerProps> = ({ icon, title, children }) => (
  <Banner>
    {icon}
    <div className="text">
      <strong>{title}</strong>
      <p>{children}</p>
    </div>
  </Banner>
);

export default InfoBanner;
